import { Button, List, ListItem, ListItemButton, ListItemContent, ListItemDecorator, Modal, ModalClose, ModalDialog, Option, Select, Stack, Typography } from "@mui/joy";

//componentes
import Header from "../../../../components/Header";
import Sidebar from "../../../../components/Sidebar";
import { useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { api } from "../../../../services/api";
import { formatarMoeda } from "../../../../utils/moedas";
import { toast } from "react-toastify";
import { User, Calendar, FileText, TrendingUp, RefreshCcw, Users } from "lucide-react";
import MultipleSelect from 'react-select'
import makeAnimated from 'react-select/animated';
import { FaFileExcel, FaSearch } from "react-icons/fa";
import { exportToExcel } from "../../../../utils/excel";

export default function AcompanhamentoGastos() {

    const animatedComponents = makeAnimated();

    const currentYear = new Date().getFullYear();
    const minYear = 2025;
    const years = [];

    const meses = [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro"
    ];

    const telasPermitidasPadrao = [
        { value: "ES", label: "Estoque" },
        { value: "MP", label: "Máquina Parada" },
        { value: "NO", label: "Normal" },
        { value: "UR", label: "Urgente" },
    ];

    const filiais = [
        { id: 1, nome: "1 - Pelicano Construcoes - ES" },
        { id: 2, nome: "2 - Pelicano Construcoes - MG" },
        { id: 4, nome: "4 - Pelicano Construcoes - MA" },
        { id: 5, nome: "5 - Pelicano Construcoes - PA" },
        { id: 7, nome: "7 - Pelicano Construcoes - SP" },
        { id: 8, nome: "8 - Pelicano Construcoes - MT" },
        { id: 100, nome: "100 - Pelicano Construcoes - GO" },
        { id: 101, nome: "101 - Pelicano Construcoes - MS" },
        { id: 102, nome: "102 - Pelicano Construcoes - SP" },
    ]

    for (let y = currentYear; y >= minYear; y--) {
        years.push(y);
    }

    const mobile = useMediaQuery('(max-width:1200px)');
    const permissoes = JSON.parse(localStorage.getItem('usuario')).user.autenticacao;

    const [year, setYear] = useState(new Date().getFullYear());
    const [usuarios, setUsuarios] = useState([]);
    const [usuarioId, setUsuarioId] = useState(0);
    const [gastosMensais, setGastosMensais] = useState({});
    const [solicitacoesSelecionadas, setSolicitacoesSelecionadas] = useState([]);
    const [modalSolicitacoes, setModalSolicitacoes] = useState(false);
    const [modalDetalhamento, setModalDetalhamento] = useState(false);
    const [mesSelecionado, setMesSelecionado] = useState("");
    const [mesDetalhamentoSelecionado, setMesDetalhamentoSelecionado] = useState("");
    const [detalhamentoSelecionado, setDetalhamentoSelecionado] = useState(null);
    const [criterios, setCriterios] = useState([{ "value": "MP", "label": "Máquina Parada" }]);
    const [loading, setLoading] = useState(false);
    const [obras, setObras] = useState([]);
    const [todasObras, setTodasObras] = useState([]);
    const [obraSelecionada, setObraSelecionada] = useState('001.00');
    const [filialSelecionada, setFilialSelecionada] = useState(1);
    const [tipoAprovador, setTipoAprovador] = useState("Aprov. Técnico");

    useEffect(() => {
        if (!permissoes.includes("gestao")) {
            window.location.href = "/centralTarefas"
            return;
        }
        else {
            obterObras();
            obterLocaisDeEstoque();
        }
    }, []);

    useEffect(() => {
        obterLocaisDeEstoque();
    }, [filialSelecionada]);

    useEffect(() => {
        if (todasObras.length > 0) {
            obterUsuarios(todasObras);
        }
        setUsuarioId(0);
    }, [obraSelecionada])

    useEffect(() => {
        if (usuarioId && year) {
            obterAprovacoesEmergenciais();
        }
    }, [usuarioId, year]);

    useEffect(() => {
        setUsuarioId(0);
        obterUsuarios(todasObras);
    }, [tipoAprovador]);

    const obterUsuarios = async (todasObras) => {
        if (!todasObras) return;
        setLoading(true);

        const response = todasObras.find(to => to.nome == obraSelecionada);
        const grupoId = response ? response.id : null;
        if (!grupoId) {
            setUsuarios([]);
            setLoading(false);
        };

        toast.loading("Buscando aprovadores técnicos...", { toastId: 1 });
        try {
            const result = await api.post('/usuariosAprovadores', { perfil: tipoAprovador, grupo_id: grupoId });
            if (result.status === 200) {
                setUsuarios(result.data);
            }
        } catch (error) {
            toast.error(JSON.stringify(error));
        } finally {
            setTimeout(() => {
                toast.dismiss();
                setLoading(false);
            }, 1000);
        }
    }

    const obterObras = async () => {
        const result = await api.get('/todosGrupos');
        if (result.status === 200) {
            setTodasObras(result.data.data);
            obterUsuarios(result.data.data);
        }
    }

    const obterAprovacoesEmergenciais = async () => {
        toast.loading("Buscando gastos...", { toastId: 1 });
        setLoading(true);
        const criteriosOpcoes = criterios.map(c => c.value);

        const response = todasObras.find(o => o.nome == obraSelecionada);

        if (!response && obraSelecionada != "%") {
            toast.dismiss();
            toast.error("Não foi possível obter o código da obra!");
            setLoading(false);
            return;
        }
        const obraNumero = obraSelecionada == "%" ? "%" : response.obra;
        const result = await api.post('/aprovacoesEmergenciaisPorAno', { usuario_id: usuarioId, ano: year, criterios: criteriosOpcoes, obra: obraNumero, tipoAprovador: tipoAprovador });
        if (result.status === 200) {
            setGastosMensais(result.data);
        }
        toast.dismiss();
        setLoading(false);
    }

    const verRequisicoes = (solicitacoes, mes) => {
        setSolicitacoesSelecionadas(solicitacoes);
        setModalSolicitacoes(true);
        setMesSelecionado(mes);
    }

    const abrirDetalhamento = (gasto, mes) => {
        setDetalhamentoSelecionado(gasto);
        setMesDetalhamentoSelecionado(mes);
        setModalDetalhamento(true);
    }

    const getCriteriosVisiveis = (gasto) => {
        if (!gasto?.criterios || typeof gasto.criterios !== 'object') return [];

        return Object.entries(gasto.criterios)
            .map(([chave, valor]) => {
                const num = valor == null ? NaN : (typeof valor === 'number' ? valor : parseFloat(String(valor).replace(/\./g, '').replace(',', '.')));
                return { chave, valor, num };
            })
            .filter(item => !isNaN(item.num) && item.num > 0);
    }

    const obterLocaisDeEstoque = async () => {
        toast.loading("Buscando locais de estoque...", { toastId: 1 });
        const usuario = JSON.parse(localStorage.getItem('usuario')).user.login;
        const token = JSON.parse(localStorage.getItem('usuario')).token;

        api.get(`/locaisEstoque?login=${usuario}&coligada=${1}&filial=${filialSelecionada}&solicitacao=`, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }
        ).then(function ({ data }) {
            let locaisEstoque = [{ localEstoque: '%', nomeLocal: 'Todos' }, ...data.data.LOCALESTOQUE];
            setObras(locaisEstoque);
            if (data.data.LOCALESTOQUE.length > 0) {
                setObraSelecionada(data.data.LOCALESTOQUE[0].localEstoque);
            }
        }).catch(error => {
            toast.error(JSON.stringify(error));
        }).finally(() => {
            toast.dismiss();
        })
    }

    const exportExcel = () => {
        const usuarioSelecionado = usuarioId && usuarios.find(u => u.id == usuarioId);
        const nomeAprovador = usuarioSelecionado.nome;
        const filial = filialSelecionada;
        const localEstoque = obraSelecionada;
        const criterio = criterios.map(c => (c.label));
        const perfil = tipoAprovador;
        const limiteCompras = tipoAprovador == 'Aprov. Técnico' ? usuarioSelecionado.maximo_compra_mp : usuarioSelecionado.maximo_compra_nr;
        const limiteMensal = tipoAprovador == 'Aprov. Técnico' ? usuarioSelecionado.limite_mensal_mp : usuarioSelecionado.limite_mensal_nr;
        const incremento = tipoAprovador == 'Aprov. Técnico' ? usuarioSelecionado.incrementoMP : usuarioSelecionado.incrementoNR;
        const ano = year;
        const gastos = Object.values(gastosMensais);

        const data = [{
            'nome': nomeAprovador,
            'filial': filial,
            'lodal de estoque': localEstoque,
            'criterio': criterio,
            'perfil': perfil,
            'limite de compras': limiteCompras,
            'limite mensal': limiteMensal,
            'incremento': incremento,
            [`jan/${ano.toString().slice(2)}`]: gastos[0].total,
            [`fev/${ano.toString().slice(2)}`]: gastos[1].total,
            [`mar/${ano.toString().slice(2)}`]: gastos[2].total,
            [`abr/${ano.toString().slice(2)}`]: gastos[3].total,
            [`maio/${ano.toString().slice(2)}`]: gastos[4].total,
            [`jun/${ano.toString().slice(2)}`]: gastos[5].total,
            [`jul/${ano.toString().slice(2)}`]: gastos[6].total,
            [`ago/${ano.toString().slice(2)}`]: gastos[7].total,
            [`set/${ano.toString().slice(2)}`]: gastos[8].total,
            [`out/${ano.toString().slice(2)}`]: gastos[9].total,
            [`nov/${ano.toString().slice(2)}`]: gastos[10].total,
            [`dez/${ano.toString().slice(2)}`]: gastos[11].total,
            [`total/${ano.toString().slice(2)}`]: gastos[12]
        }]
        exportToExcel(data, 'acompanhamento_de_gastos.xlsx');
    }

    const obterGastosPorAprovador = async () => {
        try {
            const usuario = JSON.parse(localStorage.getItem('usuario')).user.login;
            const token = JSON.parse(localStorage.getItem('usuario')).token;

            const response = await api.post('gastosPorAprovadorMPeNR',
                {
                    tipo: tipoAprovador == 'Aprov. Técnico' ? 'MP' : 'NORMAL',
                    // tipo: 'MP',
                    etapaFluxo: tipoAprovador == 'Aprov. Técnico' ? 'Faturado' : 'diligenciamento'
                    // etapaFluxo: 'Faturado'
                },
                { headers: { 'Authorization': 'Bearer ' + token } }
            );
            if (response.status === 200) {
                console.log(response.data);
                //Processando retorno
                // let data = response.data.map(res => ({
                //     ...res,
                //     criterio: tipoAprovador == 'Aprov. Técnico' ? 'MP' : 'NR'
                // }))
                const data = response.data
                    .map(res => {
                        let total = 0;

                        const mesesTratados = Object.entries(res).reduce((acc, [key, value]) => {
                            // ignora o campo aprovador
                            if (key === 'aprovador') {
                                acc[key] = value;
                                return acc;
                            }

                            // trata null ou vazio
                            if (!value) {
                                acc[key] = '0,00';
                                return acc;
                            }

                            // converte "pt-BR" para number
                            const numero = parseFloat(
                                value.replace(/\./g, '').replace(',', '.')
                            );

                            if (!isNaN(numero) && numero > 0) {
                                acc[key] = value;   // mantém o valor formatado
                                total += numero;    // soma
                            } else {
                                acc[key] = '0,00';
                            }

                            return acc;
                        }, {});

                        return {
                            ...mesesTratados,
                            criterio: tipoAprovador === 'Aprov. Técnico' ? 'MP' : 'NR',
                            totalNumerico: total, // 👈 usado só para o filtro
                            ['Gasto total']: total.toLocaleString('pt-BR', {
                                minimumFractionDigits: 2
                            })
                        };
                    })
                    // 🔥 remove quem não tem nenhum mês > 0
                    .filter(item => item.totalNumerico > 0)
                    .filter(item => item.aprovador != 'Lucas Valin')
                    .filter(item => item.aprovador != 'Matheus Murta')
                    .filter(item => item.aprovador != 'Marcos Afonso')
                    .filter(item => item.aprovador != 'Julio Rodrigues')
                    // 🧹 remove campo auxiliar
                    .map(({ totalNumerico, ...rest }) => rest);
                exportToExcel(data, 'gastos_por_aprovador.xlsx');
            }
        } catch (error) {
            console.log(error);
            toast.error(JSON.stringify(error));
        }

    }

    return (
        <Stack backgroundColor="#F5F5F5" height="100vh">
            <Header mobile={mobile} />
            <Sidebar mobile={mobile} />

            <Stack ml={mobile ? "0px" : "280px"} mt={mobile ? "50px" : "40px"} overflow={mobile ? "auto" : "auto"} height={mobile ? "100%" : "100%"} p={mobile ? "20px" : "50px"}>
                <Stack flexDirection={mobile ? "column" : "row"} flexWrap={mobile ? "nowrap" : "wrap"} justifyContent={"space-between"} alignItems={"center"}>
                    <Stack mb={"20px"}>
                        <Stack flexDirection={"row"} alignItems={"center"}>
                            <TrendingUp color="#1565c0" size={mobile ? 24 : 28} sx={{ width: 8, height: 8 }} />
                            <Typography fontSize={mobile ? 20 : 26} fontWeight={"bold"} ml={"10px"}>Acompanhamento de Gastos</Typography>
                        </Stack>
                        <Typography fontSize={14} sx={{ color: "#777" }}>Visualize e acompanhe os gastos mensais por aprovador técnico</Typography>
                    </Stack>
                    <Stack mb={"20px"} flexDirection={mobile ? "column" : "row"} mt={mobile ? "10px" : 0} width={mobile ? "100%" : "auto"} justifyContent={mobile ? "space-between" : "flex-start"} alignItems={"flex-end"} gap={mobile ? "10px" : "20px"} flexWrap={"wrap"}>
                        <Stack flexDirection={mobile ? "column" : "column"} alignItems={"flex-start"} width={mobile ? "100%" : "auto"} gap="2px">
                            <Typography>Filial</Typography>
                            <Select value={filialSelecionada} onChange={(_, value) => setFilialSelecionada(value)} sx={mobile ? { width: "100%" } : { width: "auto" }}>
                                {filiais.map((filial, index) => {
                                    return (
                                        <Option key={index} value={filial.id}>{filial.nome}</Option>
                                    );
                                })}
                            </Select>
                        </Stack>
                        <Stack flexDirection={mobile ? "column" : "column"} alignItems={"flex-start"} width={mobile ? "100%" : "auto"} gap="2px">
                            <Typography>Local de Estoque</Typography>
                            <Select value={obraSelecionada} onChange={(_, value) => setObraSelecionada(value)} sx={mobile ? { width: "100%" } : { width: "auto", maxWidth: "350px", minWidth: "200px" }}>
                                {obras.map((o, index) => {
                                    return (
                                        <Option key={index} value={o.localEstoque}>{o.localEstoque == "%" ? "Todos" : (o.localEstoque + " - " + o.nomeLocal)}</Option>
                                    );
                                })}
                            </Select>
                        </Stack>
                        <Stack flexDirection={mobile ? "column" : "column"} alignItems={"flex-start"} width={mobile ? "100%" : "auto"} gap="2px">
                            <Typography>Critério</Typography>
                            <MultipleSelect
                                value={criterios}
                                onChange={(e) => e.length > 0 ? setCriterios(e) : toast.warning("É necessário manter pelo menos 1 critério selecionado.")}
                                placeholder=""
                                isMulti
                                components={animatedComponents}
                                options={telasPermitidasPadrao}
                                noOptionsMessage={() => "Sem opções"}
                            />
                        </Stack>
                        <Stack flexDirection={mobile ? "column" : "column"} alignItems={"flex-start"} width={mobile ? "100%" : "auto"} gap="2px">
                            <Typography>Ano</Typography>
                            <Select value={year} onChange={(_, value) => setYear(value)} sx={mobile ? { width: "100%" } : { width: "auto" }}>
                                {years.map((y) => (
                                    <Option key={y} value={y}>{y}</Option>
                                ))}
                            </Select>
                        </Stack>
                        {usuarioId ? Object.values(gastosMensais).length > 0 && <Button loading={loading} sx={mobile ? { width: "100%", marginTop: "10px" } : {}} onClick={obterAprovacoesEmergenciais} variant="outlined"><RefreshCcw size={16} style={{ marginRight: "7px" }} />Atualizar</Button> : null}
                    </Stack>
                </Stack>
                <Stack flexDirection={mobile ? "column" : "row"} gap="60px" mt="30px">
                    <Stack width={mobile ? "100%" : '600px'} maxHeight={"100vh"} /*height={"73vh"}*/ bgcolor={"#fff"} border={"1px solid #ddd"} borderRadius={"20px"} sx={{ boxShadow: "lg" }}>
                        <Stack>
                            <Stack flexDirection={"row"} gap={"10px"} padding={"30px 30px 10px 30px"} alignItems={"center"}>
                                <User sx={{ width: 5, height: 5 }} color="#1565c0" />
                                {/* <Typography>Aprovadores Técnicos | Gestores de Contrato</Typography> */}
                                <Select value={tipoAprovador} onChange={(_, value) => setTipoAprovador(value)}>
                                    <Option value="Aprov. Técnico">Aprovadores Técnicos</Option>
                                    <Option value="Aprov. gestor contrato/equipamentos">Gestores de Contrato</Option>
                                    <Option value="Ultimo aprovador">Ultimo Aprovador</Option>
                                </Select>
                            </Stack>
                            <Typography ml={"35px"} fontSize={14} pb={"10px"} color="neutral">{usuarios.length} usuario(s) encontrado(s)</Typography>
                            <Stack onClick={() => loading ? null : obterGastosPorAprovador()} justifyContent={'center'} backgroundColor="#f0f0f0" alignSelf={'center'} sx={{ userSelect: 'none', transition: 'all', '&:hover': { backgroundColor: "#ddd", cursor: 'pointer' }, '&:active': { backgroundColor: "#ccc" } }} padding={'8px 8px'} borderRadius={'10px'} flexDirection={'row'} alignItems={'center'} gap={1} style={loading ? { opacity: 0.3 } : { opacity: 1 }}>
                                <FaFileExcel size={22} width={mobile ? 20 : 40} height={mobile ? 20 : 40} color="#63BE7B" style={{ opacity: 1 }} />
                                <Typography fontSize={14}>Exportar gastos por aprovador</Typography>
                            </Stack>
                            <Stack padding={"20px"}>
                                {usuarios.length > 0 ?
                                    <List sx={{ userSelect: "none", overflow: "auto", padding: "0px", maxHeight: "78vh", borderTop: '1px solid #ddd' }}>
                                        {usuarios.map((usuario, index) => {
                                            return (
                                                <ListItem key={index}>
                                                    <a
                                                        href="#gastosMensais"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            if (mobile) {
                                                                document.getElementById("gastosMensais")?.scrollIntoView({
                                                                    behavior: "smooth",
                                                                    block: "start"
                                                                });
                                                            }
                                                            setUsuarioId(usuario.id)
                                                        }}
                                                        style={{ width: "100%", textDecoration: "none" }}
                                                    >
                                                        <ListItemButton
                                                            selected={usuario.id == usuarioId}
                                                            sx={{
                                                                borderRadius: 'lg',
                                                                '&.Mui-selected': {
                                                                    bgcolor: 'primary.solidBg',
                                                                    color: 'white',
                                                                    '&:hover': {
                                                                        bgcolor: 'primary.solidHoverBg',
                                                                    },
                                                                },
                                                            }}
                                                        >
                                                            <ListItemDecorator><User size={30} sx={{ width: 12, height: 12 }} color={usuario.id == usuarioId ? "#fff" : "#1565c0"} /></ListItemDecorator>
                                                            <Stack>
                                                                <ListItemContent>{usuario.nome}</ListItemContent>
                                                                <ListItemContent sx={usuario.id == usuarioId ? { fontSize: 14, color: "#90caf9" } : { fontSize: 14, color: "#888" }}>Limite de compra: {formatarMoeda(tipoAprovador == 'Aprov. Técnico' ? usuario.maximo_compra_mp : usuario.maximo_compra_nr)}</ListItemContent>
                                                                <ListItemContent sx={usuario.id == usuarioId ? { fontSize: 14, color: "#90caf9" } : { fontSize: 14, color: "#888" }}>Limite mensal: {formatarMoeda(tipoAprovador == 'Aprov. Técnico' ? usuario.limite_mensal_mp : usuario.limite_mensal_nr)}</ListItemContent>
                                                                <ListItemContent sx={usuario.id == usuarioId ? { fontSize: 14, color: "#90caf9" } : { fontSize: 14, color: "#888" }}>Incremento: {formatarMoeda(tipoAprovador == 'Aprov. Técnico' ? usuario.incrementoMP : usuario.incrementoNR)}</ListItemContent>
                                                            </Stack>
                                                        </ListItemButton>
                                                    </a>
                                                </ListItem>
                                            );
                                        })}
                                    </List>
                                    :
                                    <Stack flexDirection={"row"} alignItems={"center"} justifyContent={"center"}>
                                        <Stack alignItems={"center"}>
                                            <Typography sx={{ color: "#aaa" }}>Nenhum usuário encontrado</Typography>
                                            <Typography sx={{ color: "#aaa", fontSize: "12px" }}>Experimente outra obra e/ou critério.</Typography>
                                        </Stack>
                                    </Stack>
                                }
                            </Stack>
                        </Stack>
                    </Stack>
                    <Stack sx={{
                        opacity: (usuarioId && Object.values(gastosMensais).length > 0) ? 1 : 0,
                        transform: (usuarioId && Object.values(gastosMensais).length > 0) ? 'translateX(0)' : 'translateX(30px)',
                        transition: 'all 0.4s ease',
                        pointerEvents: (usuarioId && Object.values(gastosMensais).length > 0) ? 'auto' : 'none',
                        // p: 2,
                        borderRadius: 'lg',
                        width: mobile ? "100%" : "100%",
                        maxWidth: mobile ? "90%" : "100%",
                        mx: 'auto',
                    }} height={mobile ? "400px" : "auto"}>
                        <Stack sx={{ boxShadow: "lg", bgcolor: '#3182ed', borderRadius: "20px" }}>
                            <Stack sx={{ padding: "30px" }}>
                                <Stack sx={{ display: "flex", flexDirection: 'row', alignItems: "center", justifyContent: "space-between" }}>
                                    <Stack>
                                        <Typography mb={1} sx={{ opacity: 0.9, fontSize: 14, color: "white" }}>Total do Ano</Typography>
                                        <Typography sx={{ fontWeight: "bold", fontSize: mobile ? 26 : 30, color: "white" }}>{formatarMoeda(gastosMensais.total_anual)}</Typography>
                                    </Stack>
                                    <Stack flexDirection={'row'} alignItems={"center"} gap={1}>
                                        <Stack onClick={exportExcel} sx={{ backgroundColor: "#fafafa", padding: "8px", boxShadow: '0px 5px 5px 1px rgba(50,50,50,0.2)', borderRadius: "10px", '&:hover': { backgroundColor: "#eee", cursor: 'pointer', boxShadow: '0px 5px 5px 3px rgba(50,50,50,0.1)' } }}>
                                            <FaFileExcel size={40} width={mobile ? 30 : 60} height={mobile ? 30 : 60} color="#63BE7B" style={{ opacity: 1 }} />
                                        </Stack>
                                        <Calendar width={mobile ? 30 : 60} height={mobile ? 30 : 60} color="white" style={{ opacity: 0.2 }} />
                                    </Stack>
                                </Stack>
                                <Stack mt={"10px"} pt={"10px"} borderTop={"1px solid rgba(255,255,255,0.2)"}>
                                    <Typography sx={{ fontSize: 14, opacity: 0.9, color: "white" }}>
                                        Aprovador selecionado: <span style={{ fontWeight: 500, padding: "5px 8px", boxShadow: "md", borderRadius: "10px", backgroundColor: "rgba(96, 157, 236, 0.5)" }}>{usuarios.length > 0 && usuarioId && usuarios.find(u => u.id == usuarioId) && usuarios.find(u => u.id == usuarioId).nome}</span>
                                    </Typography>
                                </Stack>
                            </Stack>
                        </Stack>
                        <Stack mt={"20px"} sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", flexWrap: "wrap" }}>

                            {Object.values(gastosMensais).map((gasto, index) => {
                                if (Object.values(gastosMensais).length - 1 != index)
                                    return (
                                        <Stack key={index} mb={"20px"} sx={{ borderRadius: "20px", backgroundColor: "white", boxShadow: "lg", width: mobile ? "90%" : "25%", padding: "20px" }}>
                                            <Stack mb={"15px"} sx={{ display: "flex", flexDirection: 'row', justifyContent: "space-between", alignItems: "center" }}>
                                                <Typography fontWeight={"bold"}>{meses[index]}</Typography>
                                                {gasto.solicitacoes.length > 0 && <Button onClick={() => verRequisicoes(gasto.solicitacoes, meses[index])} size="sm" sx={{ borderRadius: "10px", backgroundColor: "rgba(100, 100, 100, 1)", color: "white", margin: 0, fontSize: "12px", fontWeight: "bold" }}>{gasto.solicitacoes.length}</Button>}
                                            </Stack>

                                            <Typography mb={"5px"} sx={{ color: "#888" }}>Total do Mês</Typography>
                                            <Stack flexDirection="row">
                                            <Typography fontWeight={"bold"} fontSize={22} sx={gasto.total ? { color: "#16a249" } : { color: "#555" }}>{formatarMoeda(gasto.total)}</Typography>

                                            {(() => {
                                                const criteriosVisiveis = getCriteriosVisiveis(gasto);

                                                if (criteriosVisiveis.length === 0) return null;

                                                return (
                                                    //yeld this button to only display as a label hover clickable to open the modal
                                                    <Button
                                                        variant="plain"
                                                        color="neutral"
                                                        onClick={() => abrirDetalhamento(gasto, meses[index])}
                                                        size="sm"
                                                        sx={{
                                                                p: 0,
                                                                marginLeft: "10px",
                                                                minHeight: "auto",
                                                                fontSize: 13,
                                                                fontWeight: 500,
                                                                color: "primary.500",
                                                                '&:hover': {
                                                                    backgroundColor: "transparent",
                                                                    textDecoration: "underline",
                                                                }
                                                            }}
                                                    >
                                                        <FaSearch size="16" />
                                                    </Button>
                                                );
                                            })()}
                                            </Stack>

                                        </Stack>
                                    );
                            })}
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>

            <Modal open={modalSolicitacoes} onClose={() => setModalSolicitacoes(false)}>
                <ModalDialog>
                    <ModalClose />
                    <Typography mt={mobile ? "20px" : "0px"} sx={{ fontWeight: 500, fontSize: 22, color: "#3182ed" }}>Solicitações do mês de {mesSelecionado.toLowerCase()}</Typography>
                    <Stack overflow={"auto"} mt="20px" width={mobile ? "100%" : "500px"} maxHeight={mobile ? "80vh" : "50vh"}>
                        {solicitacoesSelecionadas.map((solicitacao, index) => {
                            return (
                                <Stack key={index} onClick={() => window.open('/solicitacao/' + solicitacao.id)} mb="10px" sx={{ backgroundColor: "#e1e6ec80", '&:hover': { backgroundColor: '#d5dce480', }, borderRadius: "10px", padding: "10px 15px", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", cursor: "pointer" }}>
                                    <Stack sx={{ display: "flex", gap: "10px", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                                        <FileText color="#777" />
                                        <Typography color="#444">N° {solicitacao.id}</Typography>
                                    </Stack>
                                    <Typography sx={{ color: "#16a249", fontWeight: 500 }}>{formatarMoeda(solicitacao.total)}</Typography>
                                </Stack>
                            );
                        })}

                    </Stack>
                </ModalDialog>
            </Modal>

            <Modal open={modalDetalhamento} onClose={() => setModalDetalhamento(false)}>
                <ModalDialog>
                    <ModalClose />
                    <Typography mt={mobile ? "20px" : "0px"} sx={{ fontWeight: 500, fontSize: 22, color: "#3182ed" }}>Detalhamento de {mesDetalhamentoSelecionado.toLowerCase()}</Typography>
                    
                    <Typography mt={mobile ? "20px" : "10px"} sx={{ fontSize: 14, opacity: 0.9, color: "black" }}>
                        Aprovador selecionado: <span style={{ fontWeight: 500, padding: "5px 8px", boxShadow: "md", borderRadius: "10px", backgroundColor: "rgba(96, 157, 236, 0.5)" }}>{usuarios.length > 0 && usuarioId && usuarios.find(u => u.id == usuarioId) && usuarios.find(u => u.id == usuarioId).nome}</span>
                    </Typography>
                    
                    <Stack overflow={"auto"} mt="20px" width={mobile ? "100%" : "450px"} maxHeight={mobile ? "80vh" : "50vh"}>
                        {detalhamentoSelecionado && (() => {
                            const criteriosVisiveis = getCriteriosVisiveis(detalhamentoSelecionado);
                            const locaisEstoque = detalhamentoSelecionado.locaisEstoque || detalhamentoSelecionado.locais_estoque || {};
                            const temLocaisEstoque = locaisEstoque && typeof locaisEstoque === 'object' && Object.keys(locaisEstoque).length > 0;

                            if (criteriosVisiveis.length === 0 && !temLocaisEstoque) {
                                return <Typography sx={{ color: "#777" }}>Nenhum detalhamento disponível.</Typography>;
                            }

                            return (
                                <Stack gap={2}>
                                    {criteriosVisiveis.length > 0 && (
                                        <Stack>
                                            <Typography sx={{ fontWeight: 600, color: "#444", mb: 1 }}>Critérios</Typography>
                                            {criteriosVisiveis.map((item, i) => {
                                                const formatted = typeof item.valor === 'number' ? formatarMoeda(item.valor) : formatarMoeda(item.num);
                                                return (
                                                    <Stack key={i} flexDirection="row" justifyContent="space-between" alignItems="center" sx={{ fontSize: 14, color: '#666', borderBottom: i < criteriosVisiveis.length - 1 ? '1px solid #eee' : 'none', py: 1 }}>
                                                        <Typography sx={{ fontSize: 14, color: '#666' }}>{item.chave}</Typography>
                                                        <Typography sx={{ fontSize: 14, color: '#666', fontWeight: 500 }}>{formatted}</Typography>
                                                    </Stack>
                                                );
                                            })}
                                        </Stack>
                                    )}

                                    {temLocaisEstoque && (
                                        <Stack>
                                            <Typography sx={{ fontWeight: 600, color: "#444", mb: 1 }}>Locais de estoque</Typography>
                                            {Object.entries(locaisEstoque).map(([nome, valor], i) => {
                                                const formatted = typeof valor === 'number' ? formatarMoeda(valor) : formatarMoeda(Number(valor) || 0);
                                                return (
                                                    <Stack key={i} flexDirection="row" justifyContent="space-between" alignItems="center" sx={{ fontSize: 14, color: '#666', borderBottom: i < Object.entries(locaisEstoque).length - 1 ? '1px solid #eee' : 'none', py: 1 }}>
                                                        <Typography sx={{ fontSize: 14, color: '#666' }}>{nome}</Typography>
                                                        <Typography sx={{ fontSize: 14, color: '#666', fontWeight: 500 }}>{formatted}</Typography>
                                                    </Stack>
                                                );
                                            })}
                                        </Stack>
                                    )}
                                </Stack>
                            );
                        })()}
                    </Stack>
                </ModalDialog>
            </Modal>
        </Stack >
    );
}